<template>
    <q-card flat bordered class="presupuesto-card">
        <q-card-section class="bg-green-1">
            <div class="row items-center">
                <q-icon name="description" size="24px" color="positive" class="q-mr-sm" />
                <div class="text-subtitle1 text-weight-medium text-positive">
                    Información del Presupuesto
                </div>
            </div>
        </q-card-section>

        <q-card-section>
            <!-- Acopio -->
            <!-- <q-expansion-item default-opened icon="store" label="Acopio" caption="Defina los términos de acopio"
                header-class="bg-grey-2 text-primary text-weight-medium"
                class="q-mb-md rounded-borders overflow-hidden">
                <q-card flat bordered>
                    <q-card-section>
                        <q-btn-toggle v-model="datos.acopio" toggle-color="primary"
                        @update:model-value="valueUpdated"
                        :options="acopioOptions" />
                    </q-card-section>
                </q-card>
            </q-expansion-item> -->

            <!-- Fecha de Necesidad -->
            <q-expansion-item default-opened icon="event" label="Fecha de Necesidad"
                caption="Seleccione la fecha requerida" header-class="bg-grey-2 text-primary text-weight-medium"
                class="q-mb-md rounded-borders overflow-hidden">
                <q-card flat bordered>
                    <q-card-section>
                        <GltnInput v-model="datos.fecha_necesidad" label="Fecha Necesidad" mask="date"
                            @update:model-value="valueUpdated" hint="Formato: YYYY/MM/DD">
                            <template v-slot:prepend>
                                <q-icon name="calendar_today" />
                            </template>
                            <template v-slot:append>
                                <q-icon name="event" class="cursor-pointer">
                                    <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                        <q-date v-model="datos.fecha_necesidad" @update:model-value="valueUpdated"
                                            mask="YYYY/MM/DD" :options="fechaNecesidadOptions">
                                            <div class="row items-center justify-end">
                                                <q-btn v-close-popup label="Cerrar" color="primary" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </GltnInput>
                    </q-card-section>
                </q-card>
            </q-expansion-item>

            <!-- Vendedor -->
            <q-expansion-item default-opened icon="person" label="Vendedor" caption="Asigne el vendedor responsable"
                header-class="bg-grey-2 text-primary text-weight-medium"
                class="q-mb-md rounded-borders overflow-hidden">
                <q-card flat bordered>
                    <q-card-section>
                        <GltnSelectVendedores v-model="datos.vendedor" label="Búsqueda de vendedor"
                            @update:model-value="valueUpdated" hint="Seleccione el vendedor asignado">
                            <template v-slot:prepend>
                                <q-icon name="badge" />
                            </template>
                        </GltnSelectVendedores>
                    </q-card-section>
                </q-card>
            </q-expansion-item>

            <!-- Puerta de Salida -->
            <q-expansion-item default-opened icon="exit_to_app" label="Puerta de Salida"
                caption="Seleccione la puerta de salida" header-class="bg-grey-2 text-primary text-weight-medium"
                class="q-mb-md rounded-borders overflow-hidden">
                <q-card flat bordered>
                    <q-card-section>
                        <GltnSelectUbicacion v-model="datos.ubicacion_id" hide-hint emit-value map-options
                            @update:model-value="valueUpdated">
                            <template v-slot:prepend>
                                <q-icon name="exit_to_app" />
                            </template>
                        </GltnSelectUbicacion>
                    </q-card-section>
                </q-card>
            </q-expansion-item>

            <!-- Condición de Pago -->
            <q-expansion-item default-opened icon="payment" label="Condición de Pago"
                caption="Defina los términos de pago" header-class="bg-grey-2 text-primary text-weight-medium"
                class="q-mb-md rounded-borders overflow-hidden">
                <q-card flat bordered>
                    <q-card-section>
                        <GltnSelectCondicionPago v-model="datos.condicion_pago" label="Condición de Pago"
                            @update:model-value="valueUpdated" hint="Seleccione la condición de pago aplicable">
                            <template v-slot:prepend>
                                <q-icon name="account_balance" />
                            </template>
                        </GltnSelectCondicionPago>
                    </q-card-section>
                </q-card>
            </q-expansion-item>

            <!-- Tipo de Cambio -->
            <q-expansion-item default-opened icon="currency_exchange" label="Tipo de Cambio"
                caption="Ingrese el tipo de cambio" header-class="bg-grey-2 text-primary text-weight-medium"
                class="q-mb-md rounded-borders overflow-hidden">
                <q-card flat bordered>
                    <q-card-section>
                        <GltnInput v-model="datos.tipo_cambio" label="Tipo de Cambio"
                            @update:model-value="valueUpdated" hint="Valor del dólar en pesos" prefix="U$S">
                            <template v-slot:prepend>
                                <q-icon name="attach_money" />
                            </template>
                        </GltnInput>
                    </q-card-section>
                </q-card>
            </q-expansion-item>

        </q-card-section>
    </q-card>
</template>

<script setup>
import { format, parse } from "date-fns";
import { reactive, computed, onMounted } from "vue";
import { useCartStore } from "@/stores/useCartStore";
import { useFetch } from '@vueuse/core'
import GltnInput from "@/components/form/GltnInput.vue";
import GltnSelectCondicionPago from "@/components/form/GltnSelectCondicionPago.vue";
import GltnSelectVendedores from "@/components/form/GltnSelectVendedores.vue";
import GltnSelectUbicacion from "@/components/form/GltnSelectUbicacion.vue";

const cartStore = useCartStore();
const datos = reactive({
    fecha_necesidad: "",
    tipo_cambio: "",
    condicion_pago: "",
    moneda: "",
    presupuesto_id: "",
    vendedor: "",
    acopio: false,
    ubicacion_id: null,
});

const acopioOptions =  [
    { label: "Gestiona Acopio", value: true },
    { label: "No gestiona Acopio", value: false },
];

const cartMode = computed(() => cartStore.getMode);
const valueUpdated = () => cartStore.setPresupuesto(datos);
const presupuestoStored = computed(() => cartStore.getPresupuesto);
function fechaNecesidadOptions(date) {
    const fecha = parse(date, 'yyyy/MM/dd', new Date());
    return fecha >= new Date();
}
onMounted(() => {
    const {
        condicion_pago,
        fecha_necesidad,
        moneda,
        presupuesto_id,
        vendedor,
        acopio,
        tipo_cambio,
        ubicacion_id,
    } = {
        ...presupuestoStored.value,
    };
    datos.condicion_pago = condicion_pago;
    datos.fecha_necesidad = fecha_necesidad;
    datos.moneda = moneda;
    datos.presupuesto_id = presupuesto_id;
    datos.vendedor = vendedor;
    datos.acopio = acopio;
    datos.tipo_cambio = tipo_cambio;
    datos.ubicacion_id = ubicacion_id;
});

onMounted(async () => {
await getCotizacion()
})

const getCotizacion = async ()=>{
    const url = 'https://api.bcra.gob.ar/estadisticascambiarias/v1.0/Cotizaciones/USD';
    const { isFetching, error, data } = await useFetch(url).get().json()
    const {results} = data.value
    if(results.length > 0){
        datos.tipo_cambio = results[0].detalle[0].tipoCotizacion
        console.log('tipo_cambio', datos.tipo_cambio)
    }
}
</script>

<style lang="scss" scoped>
.presupuesto-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// Expansion items
:deep(.q-expansion-item) {
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &.q-expansion-item--expanded {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .q-expansion-item__container {
        .q-item {
            min-height: 56px;
        }
    }
}
</style>
